import React from 'react';
import styled from 'styled-components';

import { HotelRatingSquare } from '@lt/components';
import CardImage from '../../../CardImage';

import type { IHotelImage } from './types';

export const HotelImage = (props: IHotelImage) => {
  const { rating, image, country } = props;
  const { x290x135: src, webp_x290x135: fallback } = image;

  return (
    <div>
      <StyledHotelCountry>{country}</StyledHotelCountry>
      <StyledHotelRating value={rating} count={rating} showMeta={false} />
      <CardImage src={src} fallback={fallback} loading="lazy" />
    </div>
  );
};

const StyledHotelCountry = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;

  padding: 2.5px 8px 1.5px;

  border: none;
  border-radius: 16px;

  background: #fff;
  color: #4d4d4d;

  font-size: 10px;
  line-height: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const StyledHotelRating = styled(HotelRatingSquare)`
  position: absolute;
  opacity: 0.9;

  top: 4px;
  right: 4px;
`;
